module.exports = __webpack_public_path__ + "static/media/SCAN_ITEM.15bbb365.svg";